/*
 * Ryan O'Dowd
 * 2026-03-08
 * © Copyright 2026 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  PaymentElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import React, {
  useState,
} from 'react';
import Button from '@components/common/Button';
import Dialog from '@components/common/Dialog';
import getStyles from './styles';
import hooks from '@hooks';
import {
  updateSchoolInfo,
} from '@utils/store/actions';

const PaymentMethodDialog = (props: EditSchoolDialogProps) => {
  const styles = hooks.useStyles(getStyles);
  const dispatch = hooks.useTypedDispatch();
  const i18n = hooks.useI18n();

  const stripe = useStripe();
  const elements = useElements();

  const updateSchoolInfoInFlight = hooks.useTypedSelector((state: any) => state.loadingStates.updateSchoolInfo);

  const [_errorMessage, setErrorMessage] = useState('');

  return (
    <Dialog
      style={styles.container}
      visible={true}
      onDismiss={() => props.onClose()} // @TODO: ask about unsaved changes
    >
      <Dialog.Title>Update payment method</Dialog.Title>{/* @TODO: i18n */}
      {/* @TODO: dashlane is way off here... */}
      <Dialog.Content>
        <PaymentElement />
      </Dialog.Content>
      <Dialog.Actions errorMessage={_errorMessage}>
        <Button
          mode='text'
          onPress={() => props.onClose()}
        >
          {i18n('cancel')}
        </Button>
        <Button
          disabled={updateSchoolInfoInFlight}
          loading={updateSchoolInfoInFlight}
          onPress={async () => {
            const {error: submitError} = await elements.submit();
            if (submitError) {
              setErrorMessage(submitError.message as any);
              return;
            }

            // Create the ConfirmationToken using the details collected by the Payment Element
            // and additional shipping information
            const {error, confirmationToken} = await stripe.createConfirmationToken({
              elements,
            });

            if (error) {
              setErrorMessage(error.message as any);
              return;
            }

            dispatch(updateSchoolInfo(
              props.schoolId,
              {
                stripe_confirmation_token: confirmationToken.id,
              },
              props.onClose,
            ));
          }}
        >
          {i18n('save')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

class EditSchoolDialogProps {
  onClose: () => void;
  schoolId: number;
};

export default PaymentMethodDialog;
